import { Box, BoxProps, Menu, MenuItem } from '@material-ui/core';
import { useState } from 'react';

import { StyledButton } from '@/components/modules/Metrics/shared/components/StyledButton';
import { Icon } from '@/components/shared/components/Icon';
import { Text } from '@/components/shared/components/Text';

import { TimeInterval } from '../../shared/entities/TimeInterval';
import { TimeIntervalType } from '../../shared/types/TimeIntervalType';

interface TimeIntervalSelectorProps extends BoxProps {
  timeInterval: TimeInterval;
  setTimeInterval: React.Dispatch<React.SetStateAction<TimeInterval>>;
  type?: 'button' | 'select';
}

export const TimeIntervalSelector = ({
  timeInterval,
  setTimeInterval,
  type = 'button',
  ...props
}: TimeIntervalSelectorProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  if (type === 'select') {
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    return (
      <Box {...props}>
        <StyledButton
          value={timeInterval.type}
          onClick={handleClick}
          timeInterval={timeInterval}
          color="default"
          startIcon={<Icon size={16}>calendar_today</Icon>}
          endIcon={<Icon size={20}>expand_more</Icon>}
        />
        <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
          {Object.values(TimeIntervalType).map((value) => (
            <MenuItem
              dense
              key={value}
              value={value}
              onClick={() => {
                setTimeInterval(new TimeInterval(value));
                handleClose();
              }}
              selected={value === timeInterval.type}
            >
              <Text tId={value} />
            </MenuItem>
          ))}
        </Menu>
      </Box>
    );
  }

  return (
    <Box display={'flex'} flexDirection={'column'} minWidth={'fit-content'} {...props}>
      {Object.values(TimeIntervalType).map((value) => (
        <StyledButton
          key={value}
          value={value}
          onClick={() => setTimeInterval(new TimeInterval(value))}
          timeInterval={timeInterval}
          style={{ marginBottom: 12 }}
        />
      ))}
    </Box>
  );
};
